import React, {Fragment, useState} from 'react'
import { NavLink } from "react-router-dom";
import classNames from "classnames/bind"
import * as TEXT from "constants/Strings"


import styles from "./cookie-notification.module.scss"

const cx = classNames.bind(styles)

export const CookiesNotification = () => {
    const [privacyPermission, setPrivacyPermission] = useState()

    const handleUserCookieAction = (action = false) => {
        localStorage.setItem(TEXT.LOCAL_STORAGE_PRIVACY_COOKIE, action);
        setPrivacyPermission(action)
    }

    return (
        <Fragment>
            { privacyPermission === undefined && localStorage.getItem(TEXT.LOCAL_STORAGE_PRIVACY_COOKIE) === null &&
                    <div className={cx('cookies-notification-banner')}>
                        <div className={cx('container')}>
                            <h1>Privacy Message</h1>
                            <p>This website stores cookies on your computer. These cookies are used to see how you interact with the website, as-well-as to remember your preferences (like your response to this cookie banner).
                                In addition, these cookies are used to improve the website to give you a better overall experience. To learn more
                                about the cookies used on this website, please visit the <NavLink to={'/cookie-policy'}>cookie policy</NavLink>.
                            </p>

                            <p><strong>This banner will not go away until you either accept or decline. By continuing to use the site, you are agreeing to the use of cookies. If you decline,
                                a single cookie will be used to remember your preference, and no other information will be tracked.</strong></p>

                            <span className={cx('cookies-button-wrapper')}>
                        <button className={cx(['primary-button'])} onClick={() => handleUserCookieAction(true)}>Accept</button>
                    </span>

                            <span className={cx('cookies-button-wrapper')}>
                        <button className={cx(['empty-button-light'])} onClick={() => handleUserCookieAction(false)}>Decline</button>
                    </span>
                        </div>
                    </div>
            }
        </Fragment>
    )
}